<template>
  <v-container fluid>
    <material-card
      :heading="heading"
      icon-small
      icon="mdi-account-multiple-check"
      :title="heading"
      color="primary"
    >
      <v-row class="px-5">
        <v-col
          cols="auto"
          class="mr-auto"
        >
          <v-text-field
            v-model="search"
            color="accent"
            prepend-icon="mdi-magnify"
            label="검색"
            outlined
            single-line
            hide-details
            dense
          />
        </v-col>
        <v-spacer />
        <v-col
          v-if="$vuetify.breakpoint.mdAndUp"
          cols="auto"
        >
          <v-btn
            color="primary"
            @click="addManager"
          >
            <v-icon>
              mdi-plus
            </v-icon>
            추가하기
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <v-data-table
            :headers="headers"
            :items="managers"
            :search="search"
          >
            <template v-slot:item.startDtime="{ item }">
              {{ item.startDtime | formatDateOnlyDate }}
            </template>
            <template v-slot:item.endDtime="{ item }">
              {{ item.endDtime | formatDateOnlyDate }}
            </template>
            <template v-slot:item.detail="{ item }">
              <v-btn
                icon
                @click="detailManager(item)"
              >
                <v-icon
                  color="info"
                >
                  mdi-information
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                medium
                class="mr-2"
                color="green"
                @click="editManager(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                medium
                color="error"
                @click="deleteManager(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </material-card>
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      fab
      medium
      dark
      fixed
      bottom
      right
      color="primary"
      class="v-btn--example"
      @click="addManager"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- 관리자 추가 수정 팝업 -->
    <custom-dialog
      :dialog="authDialog.dialog"
      :title="authDialog.title"
      :to-parent="authDialogClose"
      :is-edit="authDialog.isEdit"
    >
      <div slot="content">
        <v-form v-model="authDialog.isFormValid">
          <v-row
            justify="center"
            align="center"
          >
            <v-col cols="12">
              <v-select
                v-model="editedManager.role"
                :items="roles"
                dense
                outlined
                label="권한"
                hide-details
                @change="roleChanged"
              />
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="editedManager.userInfo"
                label="관리자"
                return-object
                hide-details
                outlined
                dense
                item-text="displayFullName"
                item-value="email"
                :items="people"
                :search-input.sync="searchManager"
                prepend-inner-icon="mdi-account-key"
                :rules="[rules.required]"
              >
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <v-list-item-icon>
                    <v-icon blue>
                      mdi-account-circle
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.displayFullName
                        ? data.item.displayFullName
                        : data.item.username + '/' + data.item.department + '/' + data.item.title"
                    />
                    <v-list-item-subtitle v-html="data.item.email" />
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                :nudge-right="40"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editedManager.endDtime"
                    label="만료 날짜"
                    outlined
                    readonly
                    dense
                    hide-details
                    :rules="[rules.required]"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="editedManager.endDtime"
                  no-title
                  scrollable
                  :allowed-dates="allowedDates"
                  @input="$refs.menu.save(editedManager.endDtime)"
                >
                  <v-spacer />
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedPages"
                :items="pages"
                item-value="key"
                item-text="title"
                label="페이지 권한"
                multiple
                outlined
                hide-details
                required
                :rules="[rules.required]"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 2"
                    color="primary"
                  >
                    <span>{{ item.title }}</span>
                  </v-chip>
                  <span
                    v-if="index === 2"
                    class="grey--text text-caption"
                  >
                    (+{{ selectedPages.length - 2 }} others)
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </custom-dialog>

    <!-- 상세정보 -->
    <custom-dialog
      :title="infoDialog.title"
      :dialog="infoDialog.dialog"
      :to-parent="infoDialogClose"
      :is-confirm="true"
    >
      <div slot="content">
        <v-row
          v-if="selectedManager !== null"
          justify="center"
          align="center"
        >
          <v-col cols="12">
            <v-text-field
              :value="selectedManager.role === 'sysadmin' ? 'System Admin' : 'Admin'"
              readonly
              dense
              hide-details
              outlined
              label="권한"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedManager.displayFullName || selectedManager.username"
              readonly
              dense
              hide-details
              outlined
              label="관리자"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedManager.email"
              readonly
              dense
              hide-details
              outlined
              label="관리자 이메일"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedManager.endDtime | formatDateOnlyDate"
              readonly
              dense
              hide-details
              outlined
              label="만료일자"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              :value="pages
                .filter(page => selectedManager.selectedRole.includes(page.key))
                .map(page => page.title)
                .join('\n')"
              readonly
              auto-grow
              :rows="selectedManager.selectedRole.length"
              no-resize
              row-height="20"
              dense
              outlined
              hide-details
              label="페이지 권한"
            />
          </v-col>
        </v-row>
      </div>
    </custom-dialog>

    <!-- 삭제시 팝업 -->
    <confirm-dialog
      :title="confirmDialog.title"
      :content="confirmDialog.content"
      :dialog="confirmDialog.dialog"
      :to-parent="confirmDialogClose"
    />
  </v-container>
</template>
<script>
  import { isValidateChcker, snackbarOpen } from '@/util/helpers'
  import debounce from 'lodash.debounce'
  import moment from 'moment'
  import { get } from 'vuex-pathify'

  export default {
    data: () => ({
      heading: '',
      menu: false,
      managers: [],
      loading: false,
      search: '',
      options: {
        sortDesc: true,
        page: 1,
        itemsPerPage: 10,
      },
      confirmDialog: {
        title: '관리자 삭제',
        content: '선택한 관리자를 삭제하시겠습니까?',
        dialog: false,
      },
      authDialog: {
        title: '',
        dialog: false,
        isEdit: false,
        isFormValid: false,
      },
      infoDialog: {
        title: '관리자 정보',
        dialog: false,
      },
      people: [],
      searchManager: null,
      selectedManager: null,
      editedManager: {
        role: 'admin',
        userInfo: null,
        endDtime: moment().add(1, 'years').format('YYYY-MM-DD'),
        selectedRole: [],
      },
      defaultManager: {
        role: 'admin',
        userInfo: null,
        endDtime: moment().add(1, 'years').format('YYYY-MM-DD'),
        selectedRole: [],
      },
      roles: [
        { text: 'System Admin', value: 'sysadmin' },
        { text: 'Admin', value: 'admin' },
      ],
      rules: {
        required: isValidateChcker.required,
      },
      pages: [],
      selectedPages: [],
      headers: [
        { sortable: false, text: '역할', value: 'role', align: 'center', class: 'primary--text' },
        { sortable: false, text: '성명', value: 'displayFullName', align: 'center', class: 'primary--text' },
        { sortable: false, text: '이메일', value: 'email', align: 'center', class: 'primary--text' },
        { sortable: false, text: '시작 일자', value: 'startDtime', align: 'center', class: 'primary--text' },
        { sortable: false, text: '만료 일자', value: 'endDtime', align: 'center', class: 'primary--text' },
        { sortable: false, text: '정보', value: 'detail', align: 'center', class: 'primary--text' },
        { sortable: false, text: '수정 / 삭제', value: 'actions', align: 'center', class: 'primary--text' },
      ],
    }),

    computed: {
      menus: get('app/items'),
    },

    watch: {
      searchManager: {
        handler (val) {
          this.searchPeople(val)
        },
      },
    },

    created () {
      this.heading = this.$t('page.auth-management')
    },

    mounted () {
      this.getManager()
      this.pages = this.menus.filter(menu => menu.isAdmin === true)
    },

    methods: {
      async getManager () {
        await this.$http.get('/api/v1/managers').then(response => {
          this.managers = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      setSelectedPages (role) {
        if (role === 'admin') {
          this.selectedPages = this.pages.filter(page => page.role === role).map(page => page.key)
        } else {
          this.selectedPages = this.pages.map(page => page.key)
        }
      },
      addManager () {
        this.setSelectedPages('admin')
        this.editedManager = { ...this.defaultManager }

        this.authDialog.dialog = true
        this.authDialog.isEdit = false
        this.authDialog.title = '관리자 추가'
      },
      editManager (item) {
        this.selectedManager = item
        this.editedManager = { ...this.selectedManager }
        this.selectedPages = this.editedManager.selectedRole ? this.editedManager.selectedRole : []

        this.authDialog.dialog = true
        this.authDialog.isEdit = true
        this.authDialog.title = '관리자 수정'
      },
      detailManager (item) {
        this.selectedManager = item
        this.infoDialog.dialog = true
      },
      deleteManager (item) {
        this.selectedManager = item
        this.confirmDialog.dialog = true
      },
      async authDialogClose (result) {
        if (result === 'cancel') {
          this.authDialog.dialog = false
          return
        }
        if (!this.authDialog.isFormValid) return snackbarOpen('pink', '관리자를 입력해주세요.', 'error')
        if (this.selectedPages.length < 1) return snackbarOpen('pink', '페이지 권한을 하나 이상 선택해주세요.', 'error')

        this.editedManager.selectedRole = this.selectedPages
        this.editedManager.email = this.editedManager.userInfo.email
        this.editedManager.displayFullName = this.editedManager.userInfo.displayFullName
        this.editedManager.startDtime = moment().format('YYYY-MM-DD')
        if (result === 'save') {
          await this.$http.post('/api/v1/managers', this.editedManager).then(response => {
            this.getManager()
            snackbarOpen('success', `${this.editedManager.userInfo.displayFullName} 관리자가 추가되었습니다.`, 'success')
          }).catch(error => {
            console.log(error)
          })
        } else if (result === 'edit') {
          await this.$http.put('/api/v1/managers', this.editedManager).then(response => {
            this.getManager()
            snackbarOpen('info', `${this.editedManager.userInfo.displayFullName} 관리자가 수정되었습니다.`, 'info')
          }).catch(error => {
            console.log(error)
          })
        }
        this.authDialog.dialog = false
      },
      async confirmDialogClose (result) {
        if (result === 'ok') {
          // manager 삭제
          await this.$http.delete(`/api/v1/managers/${this.selectedManager._id}`).then(async () => {
            await this.getManager()
            snackbarOpen('pink', `${this.selectedManager.userInfo.displayFullName} 관리자가 삭제되었습니다.`, 'error')
          }).catch(error => {
            console.log(error)
          })
        }
        this.confirmDialog.dialog = false
      },
      infoDialogClose () {
        this.infoDialog.dialog = false
      },
      searchPeople (val) {
        const search = val
        let searchLength = 4
        const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/
        if (check.test(search)) {
          searchLength = 2
        }
        // console.log(check.test(search), search, searchLength);
        if (search === null || search === '' || search.length < searchLength) {
          // console.log('people clear');
          this.people = []
          return
        }
        this.searchUser(search.trim())
      },
      searchUser: debounce(async function (text) {
        await this.$http.get('/api/v1/organizations', { params: { search: text, limit: 100 } }).then(response => {
          this.people = response.data.splice(0, 100)
        }).catch(error => {
          console.log(error)
        })
      }, 200),
      roleChanged (role) {
        this.setSelectedPages(role)
      },
      allowedDates (d) {
        return moment(d).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')
      },
    },
  }
</script>

<style scoped>

</style>
